import React, { useState } from 'react'

const RailLogo = (props) => {
 const { asset = [], isMobile = false, theme = {}, ottSetting } = props;
  const getPosterUrl = (posters = []) => {
    const portraitPoster = posters.find(
      (p) =>
        p.Description?.toLowerCase() === "potrait" ||
        p.Description?.toLowerCase() === "portrait"
    );
    return portraitPoster?.Url || "";
  };
  const [imgError, setImgError] = useState(false);

  return (
    <div
      style={{ backgroundColor: theme?.bgColor, padding: "10px 0", overflowX: "auto", whiteSpace: "nowrap", display: "flex", alignItems: "center", gap: "20px", display: 'flex', flexDirection: 'row', overflowX: 'auto', width: "100%", maxWidth: '54vw', scrollbarWidth: "none" }}
    >
      {asset.map((item, index) => (
        <div key={index} style={{ display: "inline-block" }}>
          <img
            src={getPosterUrl(item.Posters)}
            alt={item.Title}
            height={isMobile ? "40px" : "80px"}
            style={{
              maxHeight: "70px",
              borderRadius: "6px",
              objectFit: "cover",
               background: imgError ? "#716f6fff" : "transparent"
            }}
            
            onError={(e) => { e.target.onerror = null; e.target.src = ottSetting?.logo; setImgError(true);}}
          />
        </div>
      ))}
    </div>
  );
};

export default RailLogo;
